export const API_CLINICS = 'core/clinics';
export const API_CLINICS_THRESHOLD = 'core/clinics/thresholds';
export const API_ADMIN_PANEL_CLINICS = 'admins/admin-panel/clinics';
export const API_ADMIN_PANEL_CLINICS_UPDATE_STATUS =
  'admins/admin-panel/clinics/toggle-status';
export const API_CLINICS_RUNBOOK_LOGS = 'core/runbook-logs';
